import styled from 'styled-components'

export const Label = styled.p`
	font-size: ${props => props.fontSize || '16px'};
	font-weight: 600;
	text-transform: ${props => props.uppercase ? 'uppercase' : 'unset'};
`
